<template>
  <v-dialog v-model="modal_lock" width="500">
    <v-card>
      <v-card-title class="primary py-2 pr-2">
        <div class="d-flex justify-space-between align-center w-full white--text">
          <div>
            <v-icon class="mr-2" color="white">mdi-lock</v-icon>
            Visibility Lock
          </div>
          <v-btn icon>
            <v-icon @click="modal_lock = false">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <div class="px-4 py-8">
        <div v-show="mode == 'home'">
          <div v-if="!unlockCode">
            <p>
              You can hide contents of any folders from wondering eyes around you. Start by
              assigning a 4 digit unlock code.
            </p>
            <div class="text-center mt-10">
              <v-btn x-large color="primary" outlined tabindex="3" @click="clickSetCode">
                SET UNLOCK CODE
              </v-btn>
            </div>
          </div>
          <div v-else-if="!unlocked">
            <p>Unlock, hidden folder contents for a specific duration</p>
            <div class="d-flex justify-space-between align-center mt-10">
              <v-text-field
                outlined
                autofocus
                hide-details
                v-model.trim="duration_number"
                max-width="50"
                tabindex="1"
                type="number"
                style="width: 30px;"
                label="Duration"
                @keyup.enter="clickUnlock"
              ></v-text-field>

              <v-select
                tabindex="2"
                :items="['second', 'minute', 'hour']"
                v-model="duration_type"
                class="mx-2"
                outlined
                hide-details
                offset-y
                label="Duration Type"
                style="width: 50px;"
                :menu-props="{ offsetY: true }"
                @keyup.enter="clickUnlock"
              ></v-select>
            </div>
            <div class="text-center mt-8">
              <v-btn x-large color="primary" outlined tabindex="3" @click="clickUnlock">
                UNLOCK
              </v-btn>
              <a class="d-block mt-5 grey--text" @click="clickResetCode">Change Unlock Code</a>
            </div>
          </div>
          <div v-else>
            <div class="text-center">
              <p class="text-overline">Unlocked For</p>
              <p class="text-h6">{{ remainingText }}</p>
            </div>
            <div class="text-center mt-10">
              <v-btn x-large color="primary" outlined @click="modal_lock = false">
                CLOSE
              </v-btn>
            </div>
            <div class="text-center mt-2">
              <v-btn large color="grey" text @click="clickLock">
                LOCK AGAIN
              </v-btn>
            </div>
          </div>
        </div>

        <div v-show="mode != 'home'">
          <div class="text-center">
            <p>{{ numpadText }}</p>
          </div>
          <LockNumpad
            @clickBack="mode = 'home'"
            :mode="mode"
            :listen_keyboard="mode != 'home'"
            :expected="this.mode == 'reset-new' ? null : unlockCode"
            ref="numpad"
            @unlockSuccess="unlockSuccess"
            @newLockCode="newLockCode"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import LockNumpad from "./LockNumpad";

export default {
  name: "ModalLock",
  components: { LockNumpad },
  data() {
    return {
      mode: "home", // unlock, reset-old, reset-new
      duration_number: 1,
      duration_type: "second",
    };
  },
  mounted() {
    // assign duration number & type from local storage
    const local_duration_number = localStorage.getItem("unlock_duration_number");
    const local_duration_type = localStorage.getItem("unlock_duration_type");

    if (local_duration_number) {
      this.duration_number = parseInt(local_duration_number);
    }
    if (local_duration_type) {
      this.duration_type = local_duration_type;
    }
  },
  watch: {
    modal_lock(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.mode = "home";
        if (this.$refs.numpad) {
          this.$refs.numpad.reset();
        }
      }
    },
  },
  computed: {
    modal_lock: {
      get() {
        return this.$store.state.lock.modal;
      },
      set(value) {
        this.$store.commit("updateStateLock", { modal: value });
      },
    },
    numpadText() {
      switch (this.mode) {
        case "unlock":
          return "Please enter your unlock code:";
        case "reset-old":
          return "Please enter your CURRENT unlock code:";
        case "reset-new":
          return "Please enter your NEW unlock code:";
        default:
          return "";
      }
    },
    unlockCode() {
      return this.$store.state.user.unlockCode;
    },
    unlocked() {
      return this.$store.state.lock.unlocked;
    },
    remainingText() {
      const rem = this.$store.state.lock.timeRemaining;
      return `${rem.hour} hours ${rem.minute} minutes ${rem.second} seconds`;
    },
  },
  methods: {
    clickUnlock() {
      this.$refs.numpad.reset();
      this.mode = "unlock";
    },
    clickResetCode() {
      this.$refs.numpad.reset();
      this.mode = "reset-old";
    },
    clickSetCode() {
      this.$refs.numpad.reset();
      this.mode = "reset-new";
    },
    unlockSuccess() {
      if (this.mode == "reset-old") {
        this.mode = "reset-new";
        this.$refs.numpad.reset();
      } else if (this.mode == "unlock") {
        this.mode = "home";
        this.unlock();
      }
    },
    newLockCode(code) {
      console.log("newLockCode");
      this.mode = "home";
      this.$store.dispatch("newLockCode", code);
    },
    unlock() {
      this.$store.dispatch("saveUnlockedUntil", {
        duration_number: this.duration_number,
        duration_type: this.duration_type,
      });
    },
    clickLock() {
      this.$store.dispatch("lock");
    },
  },
};
</script>
